var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsStoreSwitch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.291,
    height: 5.27,
    viewBox: "0 0 9.291 5.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-9.022-8a.624.624,0,0,0-.441,1.066l4.019,4.022a.626.626,0,0,0,.884,0L-.541-6.934A.624.624,0,0,0-.981-8Z",
    transform: "translate(9.647 8)",
    fill: "#877b6f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsStoreSwitch);
export default __webpack_public_path__ + "static/media/icons_StoreSwitch.16214f81f39aa6a5cfc0159641b20b89.svg";
export { ForwardRef as ReactComponent };